import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import AccessibilityWidget from '@/components/AccessibilityWidget';

import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import ServiceDetailPage from '@/pages/ServiceDetailPage';
import FreeMockupPage from '@/pages/FreeMockupPage';
import FreeAISeoAnalysisPage from '@/pages/FreeAISeoAnalysisPage';
import VirtualSalesManagementPage from '@/pages/VirtualSalesManagementPage';
import WhyUsPage from '@/pages/WhyUsPage';
import PortfolioPage from '@/pages/PortfolioPage';
import WorkPage from '@/pages/WorkPage';
import ArticlesPage from '@/pages/ArticlesPage';
import BlogDetailPage from '@/pages/BlogDetailPage';
import ContactPage from '@/pages/ContactPage';
import AccessibilityPage from '@/pages/AccessibilityPage';
import NotFoundPage from '@/pages/NotFoundPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App" data-testid="app-root">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/free-mockup" element={<FreeMockupPage />} />
            <Route path="/free-ai-seo-analysis" element={<FreeAISeoAnalysisPage />} />
            <Route path="/vsm" element={<VirtualSalesManagementPage />} />
            <Route path="/virtual-sales-management" element={<VirtualSalesManagementPage />} />
            <Route path="/why-us" element={<WhyUsPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/work" element={<WorkPage />} />
            <Route path="/articles" element={<ArticlesPage />} />
            <Route path="/articles/:slug" element={<BlogDetailPage />} />
            <Route path="/blog" element={<ArticlesPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
            <Route path="/website-accessibility" element={<AccessibilityPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
          <AccessibilityWidget />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
